/**
 * Extracts and formats the initials from a display name.
 *
 * @param displayName - The full name of the user
 * @returns The uppercase initials of the user's name
 *
 * @example
 * // Returns "JD"
 * getUserInitials("John Doe");
 *
 * @example
 * // Returns "JD"
 * getUserInitials("  John   Doe  ");
 *
 * @example
 * // Returns "ABC"
 * getUserInitials("Alice Bob Charlie");
 */
export const getUserInitials = (displayName: string) => {
  return displayName
    .trim()
    .split(' ')
    .filter((name) => name.length > 0)
    .map((name) => name[0] || '')
    .join('')
    .toUpperCase();
};
